import Page from "webPage/Page";
import Track from "../util/Track";

Page.register("page-template-design-quote", () => {
    let $awardTrack = $('.js-award-slider');

    if ($awardTrack.length > 0) {
        let $track = new Track($awardTrack);
    }
});
